import React from 'react';
import {History, Route} from 'react-router';
import FontIcon from 'material-ui/FontIcon';
import FlatButton from 'material-ui/FlatButton';
import PageAncestor from 'core/common/page/pageAncestor';
import Toolmenu from 'core/components/toolmenu/toolmenu';
import mdEntityService from 'core/metamodel/mdEntityService';
import securityService from 'core/security/securityService';
import {BlockComp, MdDivider} from 'core/components/blockComp/blockComp';
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import {ExtendedPreferences, SecurableDefinitionModuleMap, User, UserContextDto, UserEntityPreference, UserProfileDto} from "core/security/securityDomain";
import {observer} from "mobx-react";
import {green500, indigo500, red300, red500} from "material-ui/styles/colors";
import UserTokenList from "core/security/component/userTokenList";
import Chip from "material-ui/Chip";
import {FormProps, IDomainObject, lovLabel} from "core/form/formUtils";
import {SecurablesResolved} from "./component/securableResolved";
import Tabs from "material-ui/Tabs/Tabs";
import Tab from "material-ui/Tabs/Tab";
import PropTypes from "prop-types";
import {action, observable} from "mobx";
import last from "lodash/last";
import SvgDone = require('react-icons/lib/md/done');
import SvgEdit = require('react-icons/lib/md/edit');
import SvgClear = require('react-icons/lib/md/clear');
import {MdCheckbox} from "core/components/fields/fields";
import uiService from "core/common/service/uiService";
import {ErrorComp} from "core/components/errorComp/errorComp";
import * as UserProfileForms from "core/security/component/userProfileForms";
import Form from "core/form/form";


@observer
export default class UserProfile extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'My Profile';
  static icon = 'user';


  static fetchData(routerParams, query) {
    console.log("UserProfile#fetchData()");

    let metadataPromise = mdEntityService.fetchEntityMetadata(['User', 'UserToken'], [{entity: 'Tenant', lov: true}, 'Party', 'ExtendedPreferences',
      {entity: 'SecurityRole', lov: true}, {entity: 'MODULE', lov: true}, {entity: 'SECURABLETYPE', lov: true}, {entity: 'SECURABLE', lov: true}, {entity: 'INVOICEWARNING', lov: true}]);

    let userProfilePromise = securityService.readUserProfile(securityService.currentUser.username);
    let securablesPromise = securityService.getSecurables();

    return Promise.all([metadataPromise, userProfilePromise, securablesPromise])
      .then(([entityMap, userProfileObject, securables]: [any, UserProfileDto, SecurableDefinitionModuleMap]) => {
        securityService.userProfileObject = userProfileObject;
        securityService.securables = securables;
      });
  }

  static contextTypes = {
    router: PropTypes.func.isRequired
  };


  @observable private activeTab: string;

  componentWillMount() {
    const params = this.context.router.getCurrentParams();
    this.activeTab = (params.tab) ? params.tab : 'info';
  }

  componentDidMount() {
    this[this.activeTab]();
  }

  componentWillUnmount() {
    securityService.userProfileObject = null;
  }


  onSetPassword = (evt) => {
    console.log('onSetPassword');
    this.context.router.transitionTo('setPassword', {mode: 'USER'});
  };


  onBack = (evt) => {
    console.log('onBack %O', this.context.router);
    this.context.router.goBack();
  };

  handleChange = (value: string) => {
    this.activeTab = value;
    this[this.activeTab]();

    const routeName = last<Route>(this.context.router.getCurrentRoutes()).name;
    const params = this.context.router.getCurrentParams();
    params.tab = value;

    console.log("handleChange %s , %o", value, params);

    this.context.router.replaceWith(routeName, params, undefined);
  };

  info() {
  }

  rights() {
  }

  apiTokens() {
  }

  entityPreferences() {

  }


  render() {
    console.debug('%c userProfile render', 'background-color: yellow');


    return (
      <main className="main-content">
        {this._createToolMenu(securityService.userProfileObject)}


        <Tabs
          value={this.activeTab}
          onChange={this.handleChange}
        >
          <Tab label="Info" value="info">
            <MainTab/>
          </Tab>
          <Tab label="My Rights" value="rights">
            <div>
              <BlockComp noPadding style={{display: 'flex', flexDirection: 'column'}}>
                <SecurablesResolved entities={mdEntityService.entityMap} permissionMap={securityService.userProfileObject.user.permissionMap} securables={securityService.securables}/>
              </BlockComp>

              <MdDivider inset marginTop={20} marginBottom={20}/>

              <BlockComp noPadding header={<span>My Restrictions</span>}>
                <div
                  style={{marginLeft: 20, marginTop: 15, display: 'flex', flexWrap: 'wrap'}}>
                  {securityService.userProfileObject.user.restrictions.map((rst, index) => <Chip key={index}
                                                                                                 style={{margin: 3, backgroundColor: red300}}>{lovLabel(rst)}</Chip>)}
                </div>
              </BlockComp>
            </div>
          </Tab>
          <Tab label="API Tokens" value="apiTokens">
            <BlockComp noPadding style={{display: 'flex', flexDirection: 'column'}}>
              <UserTokenList userObject={securityService.userProfileObject.user} entities={mdEntityService.entityMap}/>
            </BlockComp>
          </Tab>

          <Tab label="Entity Preferences" value="entityPreferences">
            <EntityPreferences/>
          </Tab>

        </Tabs>

      </main>
    );

  }


  _createToolMenu(userProfileObject) {
    return (
      <Toolmenu backAction={this.onBack} backDisabled={History.length <= 1}>
        <FlatButton onClick={this.onSetPassword} label="Set password"/>
      </Toolmenu>
    );
  }


}


@observer
class MainTab extends React.Component<any, any> {

  static contextTypes = {
    router: PropTypes.func.isRequired
  };


  render() {

    let tenantLovs = mdEntityService.getEntity('Tenant').lovItems.filter(li => securityService.userProfileObject.user.tenants.includes(li.value as any));

    return (
      <BlockComp style={{marginTop: 10}}>
        <div style={{display: 'flex', alignItems: 'baseline'}}>
          <div style={{fontSize: '18px', fontWeight: 'bold', marginRight: 8}}>{securityService.userProfileObject.user.username}</div>
          <FlatButton onClick={this.onDetail} primary={true} label="Edit" labelPosition="after"
                      labelStyle={{paddingLeft: 8}} style={{paddingLeft: 5}}>
            <FontIcon className="fa fa-pencil" style={{fontSize: 14, color: indigo500}}/>
          </FlatButton>
          <div>Available Tenants:</div>
          <ul>
            {
              tenantLovs.map(li => (<li style={{listStyleType: 'none'}} key={li.value}>{li.label}</li>))
            }
          </ul>
        </div>
      </BlockComp>
    );
  }

  onDetail = (evt) => {
    console.log('onDetail');
    this.context.router.transitionTo('partyDetail', {id: securityService.userProfileObject.user.party.value});
  };

}


const GREEN_STYLE = {color: green500, fontWeight: "bold"};


@observer
class EntityPreferences extends React.Component<any, any> {

  static contextTypes = {
    router: PropTypes.func.isRequired
  };

  @observable editing: boolean;

  render() {

    let userProfileObject = securityService.userProfileObject;
    let tenantLovs = mdEntityService.getEntity('Tenant').lovItems.filter(li => userProfileObject.user.tenants.includes(li.value as any));

    return (
      <BlockComp style={{marginTop: 10, display: "flex"}}>

        <ErrorComp messages={userProfileObject.$errors}/>

        <table className="zz-simple-table">
          <thead>
            <tr>
              <th>Entity</th>
              <th>Confirm delete</th>
            </tr>
          </thead>
          {
            userProfileObject.entityPreferences.map(ep => {
              const expEntity = mdEntityService.getEntity('ExtendedPreferences');
              const formName = ep.entityName +  'PreferenceForm';
              const DetailComponentForm: React.ComponentClass<FormProps<ExtendedPreferences, UserProfileDto>> = UserProfileForms[ formName];
              let detailComponent = null;
              if (DetailComponentForm) {
                const ClosedContent = mdEntityService.getClosedContent(formName);
                const form: Form<any> = ep.extendedPreferences.getForm(formName);
                const fields = form.setupFields(ep.extendedPreferences, userProfileObject, expEntity, mdEntityService.entityMap, null);

                detailComponent = (this.editing) ?  <DetailComponentForm dataObject={ep.extendedPreferences} rootObject={userProfileObject} entities={mdEntityService.entityMap} entity={expEntity}/>
                  : <ClosedContent dataObject={ep.extendedPreferences} entities={mdEntityService.entityMap} entity={expEntity} fields={fields}/>
              }


              return (
              <tbody key={ep.entityName}>
                <tr >
                  <td>{ep.entityName}</td>
                  <td>
                    {!this.editing && ep.confirmDelete && <SvgDone style={GREEN_STYLE} size={16}/>}
                    {this.editing && <MdCheckbox name={"confirmDelete_" + ep.entityName} checked={ep.confirmDelete}
                                                 onCheck={this.onCheck.bind(this, ep)}/>}
                  </td>
                </tr>
                { !!detailComponent &&
                  <tr>
                    <td colSpan={2} style={{borderTop: "0px"}}>
                      {detailComponent}
                    </td>
                  </tr>
                }
              </tbody>
            )})
          }
        </table>

        <div style={{display: "flex", flexDirection: "column", columnGap: 10, margin: "20px 10px", width: "100%", alignItems: "center"}}>

          {!this.editing &&
            <FlatButton onClick={this.onEdit} primary={true} label="Edit" labelPosition="after"
                        labelStyle={{paddingLeft: 8}} style={{paddingLeft: 5, minWidth: 100}}>
              <SvgEdit style={{color: indigo500}} size={16}/>
            </FlatButton>
          }

          {this.editing &&
            <FlatButton onClick={this.onSave} primary={true} label="Save" labelPosition="after"
                        labelStyle={{paddingLeft: 8}} style={{paddingLeft: 5, minWidth: 100}}>
              <SvgDone style={{color: green500}} size={16}/>
            </FlatButton>
          }

          {this.editing &&
            <FlatButton onClick={this.onCancel} primary={true} label="Cancel" labelPosition="after"
                        labelStyle={{paddingLeft: 8}} style={{paddingLeft: 5, minWidth: 100}}>
              <SvgClear style={{color: red500}} size={16}/>
            </FlatButton>
          }
        </div>


      </BlockComp>
    );
  }

  @action onCheck = (ep: UserEntityPreference) => {
    console.log('onCheck ', ep);
    ep.confirmDelete = !ep.confirmDelete;
    securityService.userProfileObject.$dirty = true;
  };


  onEdit = (evt) => {
    console.log('onEdit');
    this.editing = true;
  };


  onSave = (evt) => {
    console.log('onSave');
    securityService.saveUserProfile(securityService.userProfileObject.user.username, new UserProfileDto({entityPreferences: securityService.userProfileObject.entityPreferences}))
      .then(action("userProfileSave-action", (userProfileJson: IDomainObject) => {
        securityService.userProfileObject.cleanAfterSave(userProfileJson);
        uiService.hideToolbarActionFlag();
        this.editing = false;
        return securityService.readCurrentUserContext()
      })).then((userContextDto: UserContextDto) => {
      if (userContextDto) {
        securityService.setUserContextDto(userContextDto);
      }
    }).catch(error => {
      console.log("Error %O", error);
      securityService.userProfileObject.$errors = error.getMessages();
    });
  };

  onCancel = (evt) => {
    console.log('onCancel');
    securityService.readUserProfile(securityService.currentUser.username)
      .then((userProfileDto) => {
        securityService.userProfileObject = userProfileDto;
        this.editing = false;
      })
  };


}



// WEBPACK FOOTER //
// ./src/core/security/userProfile.tsx